import { get } from "lodash-es";
import axios from "axios";
import moment from "moment";

export default {
  namespaced: true,
  state: () => ({
    cliente: null,
    vehiculo: null,
    contratoTipo: null,
    grupo: null,
    aditivos: [],
    empresaPropia: null,
    empresa: null,
    subfactura: null,
    vendedor: 0, //predeterminado `0 - MQ`
    instalador: null,
    ventaNotas: "",
    ubicacionAvl: "",
    instalacionEnTaller: 0,
    emularSensorDeContacto: { id: 0, nombre: "No requerido" },
    sensorIN2: null,
    sensorDeMovimiento: null,
    avlChip: null,
    descripcionDeViaticos: "",
    monto: 0,
    fechaAlta: moment().format("YYYY-MM-DD"),
    viaticos: {
      viaticosCliente: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
      viaticosInstalador: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
    },
  }),
  mutations: {
    reinit(state) {
      state.vehiculo = null;
      state.contratoTipo = null;
      state.grupo = null;
      state.aditivos = [];
      state.empresa = null;
      state.empresaPropia = null;
      state.subfactura = null;
      state.avlChip = null;
      state.vendedor = 0;
      state.instalador = null;
      state.ventaNotas = "";
      state.ubicacionAvl = "";
      state.instalacionEnTaller = 0;
      state.emularSensorDeContacto = { id: 0, nombre: "No requerido" };
      state.sensorIN2 = {
        codigo: 0,
        nombre: "No requerido",
      };
      state.sensorDeMovimiento = 0;
      state.descripcionDeViaticos = "";
      state.monto = 0;
      state.fechaAlta = moment().format("YYYY-MM-DD");
      state.viaticos = {
        viaticosCliente: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      };
    },
    setFechaAlta(state, payload) {
      state.fechaAlta = payload;
    },

    setDescripcionDeViaticos(state, payload) {
      state.descripcionDeViaticos = payload;
    },
    setMonto(state, payload) {
      state.monto = payload;
    },
    setCliente(state, payload) {
      state.cliente = payload;
    },
    setVehiculo(state, payload) {
      state.vehiculo = payload;
    },
    setContratoTipo(state, payload) {
      state.contratoTipo = payload;
    },
    setGrupo(state, payload) {
      state.grupo = payload;
    },
    setAditivos(state, payload) {
      state.aditivos = payload;
    },
    setEmpresaPropia(state, payload) {
      state.empresaPropia = payload;
    },
    setEmpresa(state, payload) {
      state.empresa = payload;
    },
    setSubfactura(state, payload) {
      state.subfactura = payload;
    },
    setAvlChip(state, payload) {
      state.avlChip = payload;
    },
    setVendedor(state, payload) {
      state.vendedor = payload;
    },
    setInstalador(state, payload) {
      state.instalador = payload;
    },
    setVentaNotas(state, payload) {
      state.ventaNotas = payload;
    },
    setUbicacionAvl(state, payload) {
      state.ubicacionAvl = payload;
    },
    setInstalacionEnTaller(state, payload) {
      state.instalacionEnTaller = payload;
    },
    setEmularSensorDeContacto(state, payload) {
      state.emularSensorDeContacto = payload;
    },
    setSensorIN2(state, payload) {
      state.sensorIN2 = payload;
    },
    setSensorDeMovimiento(state, payload) {
      state.sensorDeMovimiento = payload;
    },
    setViaticos(state, payload) {
      state.viaticos = payload;
    },
    setViaticosCliente(state, payload) {
      state.viaticos.viaticosCliente = payload;
    },
    setViaticosInstalador(state, payload) {
      state.viaticos.viaticosInstalador = payload;
    },
  },
  actions: {
    async submitContrato({ state }, payload) {
      try {
        const viaticosFormateados =
          this.getters["Contratos/NuevoContrato/getFormattedViaticos"];

        const parameters = [
          { name: "id_vehiculo", value: state.vehiculo.id_vehiculo },
          { name: "id_cliente", value: payload.idCliente },
          { name: "id_avl", value: state.avlChip.id_avl },
          { name: "id_chip", value: state.avlChip.id_chip },
          { name: "vendedor", value: get(state, "vendedor.id", 0) }, //predeterminado `0 - MQ`
          { name: "id_grupo", value: get(state, "grupo.id_grupo", 0) }, //
          { name: "comentarioDeVenta", value: get(state, "ventaNotas", "") },
          { name: "id_instalador", value: state.instalador.id_instaladores },
          { name: "ubicacion_avl", value: state.ubicacionAvl },
          {
            name: "id_empresas_propias",
            value:
              state.empresaPropia.id_empresas_propias == 0
                ? null
                : get(state, "empresaPropia.id_empresas_propias", null),
          },
          {
            name: "id_empresa",
            value: get(state, "empresa.id_empresa", null),
          },
          {
            name: "subfactura",
            value: get(state, "subfactura.subfactura", null),
          },
          { name: "taller", value: state.instalacionEnTaller },
          {
            name: "aditivosCSV",

            value: state.aditivos
              .map((aditivo) => aditivo.id_precios_aditivos)
              .join(","),
          },
          {
            name: "SensorDeContactoAlternativo",
            value: get(state, "emularSensorDeContacto.id", null),
          },
          {
            name: "sensor_IN2",
            value: get(state, "sensorIN2.id_alertas_lista", 0),
          },

          {
            name: "sensorDeMovimientoTiempo",
            value: state.sensorDeMovimiento,
          },

          {
            name: "id_tipo_contrato",
            value: state.contratoTipo.id_contrato_tipos,
          },
          {
            name: "descripcion_viaticos",
            value: state.descripcionDeViaticos,
          },
          { name: "monto_viaticos", value: state.monto },
          { name: "fecha_alta", value: state.fechaAlta },
          {
            name: "viaticos_cliente_activo",
            value: viaticosFormateados.viaticosCliente.activo,
          },
          {
            name: "viaticos_cliente_combustible_activo",
            value: viaticosFormateados.viaticosCliente.combustible.activo,
          },
          {
            name: "viaticos_cliente_combustible_kilometros",
            value: viaticosFormateados.viaticosCliente.combustible.kilometros,
          },
          {
            name: "viaticos_cliente_combustible_monto_calculado",
            value:
              viaticosFormateados.viaticosCliente.combustible.montoCalculado,
          },
          {
            name: "viaticos_cliente_combustible_descripcion",
            value: viaticosFormateados.viaticosCliente.combustible.descripcion,
          },
          {
            name: "viaticos_cliente_adicional_activo",
            value: viaticosFormateados.viaticosCliente.viaticoAdicional.activo,
          },
          {
            name: "viaticos_cliente_adicional_monto",
            value: viaticosFormateados.viaticosCliente.viaticoAdicional.monto,
          },
          {
            name: "viaticos_cliente_adicional_descripcion",
            value:
              viaticosFormateados.viaticosCliente.viaticoAdicional.descripcion,
          },
          {
            name: "viaticos_instalador_activo",
            value: viaticosFormateados.viaticosInstalador.activo,
          },
          {
            name: "viaticos_instalador_combustible_activo",
            value: viaticosFormateados.viaticosInstalador.combustible.activo,
          },
          {
            name: "viaticos_instalador_combustible_kilometros",
            value:
              viaticosFormateados.viaticosInstalador.combustible.kilometros,
          },
          {
            name: "viaticos_instalador_combustible_monto_calculado",
            value:
              viaticosFormateados.viaticosInstalador.combustible.montoCalculado,
          },
          {
            name: "viaticos_instalador_combustible_descripcion",
            value:
              viaticosFormateados.viaticosInstalador.combustible.descripcion,
          },
          {
            name: "viaticos_instalador_adicional_activo",
            value:
              viaticosFormateados.viaticosInstalador.viaticoAdicional.activo,
          },
          {
            name: "viaticos_instalador_adicional_monto",
            value:
              viaticosFormateados.viaticosInstalador.viaticoAdicional.monto,
          },
          {
            name: "viaticos_instalador_adicional_descripcion",
            value:
              viaticosFormateados.viaticosInstalador.viaticoAdicional
                .descripcion,
          },
        ];

        const resp = await axios.post("/execute", {
          method: "CLI.CrearContrato",
          parameters: parameters,
        });

        return resp;
      } catch (e) {
        return {
          data: { ok: false, message: e.toString() },
        };
      }
    },
  },
  getters: {
    getFormattedViaticos(state) {
      return {
        viaticosCliente: {
          activo: state.viaticos.viaticosCliente.activo,
          combustible: {
            activo: state.viaticos.viaticosCliente.combustible.activo,
            kilometros:
              Number(state.viaticos.viaticosCliente.combustible.kilometros) ||
              0,
            montoCalculado:
              Number(
                state.viaticos.viaticosCliente.combustible.montoCalculado,
              ) || 0,
            descripcion:
              state.viaticos.viaticosCliente.combustible.descripcion || "",
          },
          viaticoAdicional: {
            activo: state.viaticos.viaticosCliente.viaticoAdicional.activo,
            monto:
              Number(state.viaticos.viaticosCliente.viaticoAdicional.monto) ||
              0,
            descripcion:
              state.viaticos.viaticosCliente.viaticoAdicional.descripcion || "",
          },
        },
        viaticosInstalador: {
          activo: state.viaticos.viaticosInstalador.activo,
          combustible: {
            activo: state.viaticos.viaticosInstalador.combustible.activo,
            kilometros:
              Number(
                state.viaticos.viaticosInstalador.combustible.kilometros,
              ) || 0,
            montoCalculado:
              Number(
                state.viaticos.viaticosInstalador.combustible.montoCalculado,
              ) || 0,
            descripcion:
              state.viaticos.viaticosInstalador.combustible.descripcion || "",
          },
          viaticoAdicional: {
            activo: state.viaticos.viaticosInstalador.viaticoAdicional.activo,
            monto:
              Number(
                state.viaticos.viaticosInstalador.viaticoAdicional.monto,
              ) || 0,
            descripcion:
              state.viaticos.viaticosInstalador.viaticoAdicional.descripcion ||
              "",
          },
        },
      };
    },
  },
};
